import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OnBoardingFormService {

  public bearer: string|undefined;
  public formId: string|undefined;
}
